import AuthService, {
  IAuthPasswordLessVerifyPayload,
  IAuthPasswordLessVerifyResponse,
} from '@/app/services/auth'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { useMutation } from 'react-query'

export function useAuthVerify() {
  return useMutation<
    IApiIndividualResponse<IAuthPasswordLessVerifyResponse>,
    ErrorResponse,
    IAuthPasswordLessVerifyPayload
  >(AuthService.POST_PATH_PASSWORD_LESS_VERIFY, AuthService.passwordLessVerify)
}
